import { render, staticRenderFns } from "./IDPC.vue?vue&type=template&id=c017c91e&"
import script from "./IDPC.vue?vue&type=script&lang=js&"
export * from "./IDPC.vue?vue&type=script&lang=js&"
import style0 from "./IDPC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c017c91e')) {
      api.createRecord('c017c91e', component.options)
    } else {
      api.reload('c017c91e', component.options)
    }
    module.hot.accept("./IDPC.vue?vue&type=template&id=c017c91e&", function () {
      api.rerender('c017c91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/IDPC.vue"
export default component.exports